const en = {
  ourTools: 'Our Tools',
  usedBy: 'Used By',
  supportedBy: 'UX Core Supported By',
};
export default en;
